import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/promotions/end-user/apple-products-lucky-draw'
const QUERY_KEY = 'apple-lucky-draw'

export const useGetEndUserAppleLuckyDraws = (params = {}, config = {}) =>
  useQuery(
    [`${QUERY_KEY}s`, params],
    async () => (await axios.get(ENDPOINT, { params })).data,
    config,
  )

export const useGetEndUserAppleLuckyDrawById = (id, config = {}) =>
  useQuery([QUERY_KEY, id], async () => (await axios.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetEndUserAppleLuckyDrawCanSubmit = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'form', 'can-submit'],
    async () => (await axios.get(`${ENDPOINT}/form/can-submit`)).data,
    config,
  )

export const usePostEndUserAppleLuckyDraw = (config = {}) =>
  useMutation((newData) => axios.post(ENDPOINT, newData), config)

export const usePostExportEndUserAppleLuckyDraw = (config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/export`, null, { responseType: 'blob' }), config)

export const usePostResendSMSEndUserAppleLuckyDraw = (id, config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}/${id}/resend-sms`, null), config)

export const usePatchEndUserAppleLuckyDrawApprove = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/approve`, updatedData), config)

export const usePatchEndUserAppleLuckyDrawReject = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/reject`, updatedData), config)
